import { type IModuleContext } from '@/common/types/module'
import * as NavigationItemsBuilder from '@/agent/entities/navigation'
import { type NavAction, type NavItem, type NavActionList } from '@/common/types/navigation'
import { type RoleList } from '@/common/types/session'

/**
 * Build navigation items
 */

export const buildNavigationItems = (context: IModuleContext, actionList: NavActionList, roles?: RoleList) => {
  let items: NavItem[] = []

  if (actionList) {
    for (const action of actionList) {
      const hasAccessRight = roles === undefined || !action.role || roles.includes(action.role)
      if (hasAccessRight) {
        const actionsItems = buildNavigationItem(context, action.type, action)
        if (actionsItems) {
          items = [...items, ...actionsItems]
        }
      }
    }
  }

  return items
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function buildNavigationItem(context: IModuleContext, key: string, action: NavAction<any>): NavItem[] {
  switch (key) {
    case 'create-case':
      return [...new NavigationItemsBuilder.CreateCaseNavigationItemBuilder(context, action)]
    case 'create-entity': {
      const parentItems = [...new NavigationItemsBuilder.CreateEntityNavigationItemBuilder(context, action)]
      if (parentItems.length > 0 && Array.isArray(action.actions) && action.actions.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        parentItems[0].children = action.actions.flatMap((childAction: NavAction<any>) => buildNavigationItem(context, childAction.type, childAction))
      }
      return parentItems
    }
    case 'create-customer':
      return [...new NavigationItemsBuilder.CustomerNavigationItemBuilder(context, action)]
    case 'create-company':
      return [...new NavigationItemsBuilder.CompanyNavigationItemBuilder(context, action)]
    case 'create-mail':
      return [...new NavigationItemsBuilder.MailNavigationItemBuilder(context, action)]
    case 'case-action':
    case 'default':
      return [...new NavigationItemsBuilder.CaseActionNavigationItemBuilder(context, action)]
    default:
      break
  }

  return []
}
